import { Injectable } from '@angular/core';
import { RequestServiceProvider } from '../providers/request-service-provider/request-service-provider';
import { Geolocation } from '@capacitor/geolocation';
import { LocationService } from '../location/location.service';

@Injectable({
  providedIn: 'root',
})
export class RequestBookingHelperService {

  /**
   *
   */
  constructor(
    private readonly requestServiceProvider: RequestServiceProvider,
    private readonly locationService: LocationService
  ) { }

  async getCurrentLocation() {

    let latitude = 0;
    let longitude = 0;

    if (this.requestServiceProvider.readCurrentLatitude() && this.requestServiceProvider.readCurrentLongitude()) {
      latitude = this.requestServiceProvider.readCurrentLatitude() ?? 0;
      longitude = this.requestServiceProvider.readCurrentLongitude() ?? 0;
      // this.getVendorList();
    }
    else {
      //const _ = await this.locationService.requestPermission();
      const currentPosition = await Geolocation.getCurrentPosition({
        timeout: 30000
      });
      const coords = currentPosition.coords;

      latitude = coords.latitude;
      longitude = coords.longitude;
      this.requestServiceProvider.setCurrentLatitude(coords.latitude);
      this.requestServiceProvider.setCurrentLongitude(coords.longitude);
      // this.getVendorList();
    }


    return {
      latitude, longitude
    };
  }

  async getPlacesPrediction(
    queryValue: string,
    autoCompleteService: google.maps.places.AutocompleteService
  ): Promise<google.maps.places.AutocompletePrediction[]> {

    if (!queryValue || queryValue.length <= 1 || !autoCompleteService) {
      return Promise.resolve([]);
    }

    const config: google.maps.places.AutocompletionRequest = {
      input: queryValue,
      types: ['geocode'],
      componentRestrictions: { country: 'gb' }
    };

    return new Promise((resolve) => {
      autoCompleteService.getPlacePredictions(
        config,
        (
          predictions: google.maps.places.AutocompletePrediction[] | null,
          status
        ) => {
          if (
            status === google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            resolve(predictions);
          } else {
            resolve([]);
          }
        }
      );
    });
  }

  async geocodeAddress(address: string): Promise<{ latitude: number; longitude: number }> {
    if (!address || !address.trim()) {
      return { latitude: 0, longitude: 0 };
    }

    const geocoder = new google.maps.Geocoder();

    return new Promise((resolve) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results && results.length > 0) {
          resolve({
            latitude: results[0].geometry.location.lat(),
            longitude: results[0].geometry.location.lng()
          });
        } else {
          resolve({
            latitude: 0,
            longitude: 0
          });
        }
      });
    });
  }

}
